webpackJsonp([129236653009385],{

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _articleListing = __webpack_require__(56);
	
	var _articleListing2 = _interopRequireDefault(_articleListing);
	
	var _eventListing = __webpack_require__(42);
	
	var _eventListing2 = _interopRequireDefault(_eventListing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data,
	      pathContext = _ref.pathContext;
	
	  var articles = [],
	      events = [];
	
	  if (data.allArticlesYaml) {
	    articles = data.allArticlesYaml.edges.map(function (edge) {
	      return edge.node;
	    });
	  }
	
	  if (data.allEventsYaml) {
	    events = data.allEventsYaml.edges.map(function (edge) {
	      return edge.node;
	    });
	  }
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'breadcrumb' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/' },
	        'Home'
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        ' \u203A '
	      ),
	      'Tag: ',
	      pathContext.tag
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'title' },
	      'Tag: ',
	      pathContext.tag
	    ),
	    _react2.default.createElement(_eventListing2.default, { events: events }),
	    _react2.default.createElement(_articleListing2.default, { articles: articles })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tag-js-78832a5fee1e5eea56b5.js